import { keepPreviousData } from '@tanstack/react-query'

/**
 * Overrides de cache por domínio, numa tabela só em vez de espalhados pelos hooks.
 *
 * `staleTime` alto o bastante para abrir e fechar o drawer não refazer rede; curto o bastante para
 * dado de voo não parecer atual quando não é.
 */
export const domainQueryOptions = {
  /**
   * Detalhe de aeródromo: ROTAER, INFOTEMP, AIPSUP, METAR/TAF.
   *
   * `staleTime: 0` é deliberado. Com `initialData` do repositório, um `staleTime` de minutos faria a
   * abertura de um aeródromo **pular** a revalidação sempre que o dado em cache fosse mais novo que a
   * janela — e o comportamento anterior era revalidar SEMPRE ao abrir. Para METAR, TAF e NOTAM isso
   * não é economia de rede, é dado de voo potencialmente desatualizado apresentado como atual.
   * O `gcTime` longo é que garante a pintura instantânea; o `staleTime` curto garante o refresh.
   */
  adhpDetail: {
    staleTime: 0,
    gcTime: 30 * 60_000,
    refetchInterval: 10 * 60_000,
    // Sem isto, o intervalo continuaria batendo com a aba em background.
    refetchIntervalInBackground: false,
    // Dado aeronáutico depois de reconexão vale sempre revalidar, mesmo dentro do staleTime.
    refetchOnReconnect: 'always',
    placeholderData: keepPreviousData
  },

  /** Dataset de NOTAM: o mais perecível. */
  notamDataset: {
    staleTime: 30 * 60_000,
    gcTime: Infinity,
    refetchOnReconnect: 'always'
  },

  /**
   * Listas do usuário (rotas, aeronaves, cartas, geometrias, pontos, P&B, pesos padrão).
   * `refetchOnWindowFocus` ligado porque essas listas também são editadas no app legado.
   */
  userLists: {
    staleTime: 30_000,
    gcTime: 30 * 60_000,
    refetchOnWindowFocus: true
  },

  /** Catálogos estáticos: modelos de aeronave, templates de P&B. */
  staticCatalog: {
    staleTime: Infinity,
    gcTime: Infinity
  },

  /** Manifest de meteorologia — hoje re-baixado a cada frame de animação. */
  meteorologyManifest: {
    staleTime: 2 * 60_000,
    gcTime: 10 * 60_000
  }
} as const
